<template>
  <div class="main">
    <div class="header flexR">
      <div class="flex1">
        <img src="../assets/imgs/logo.png" class="logo" />
      </div>
      <div class="flexR">
        <div class="appstore" :class="navtype == 1 ? 'active' : 'noactive'" @click="changeNavBar(1)">手机商店</div>
        <div class="pageName" :class="navtype == 2 ? 'active' : 'noactive'" @click="changeNavBar(2)">平板应用</div>
        <div class="workName" :class="navtype == 3 ? 'active' : 'noactive'" @click="changeNavBar(3)">办公应用</div>
      </div>
    </div>
    <div class="container" v-if="navtype == 1">
      <div class="xmgj">
        <div class="xmgjInfo">
          <div class="line"></div>
          <div class="name">小马国炬APP</div>
          <div class="introduce">一站式供应链服务中心 物流企业的贴身管家</div>
          <el-button type="primary" round @click="downLoadApp('ydxlm')">立即下载</el-button>
        </div>
        <img src="../assets/imgs/xmgj.png" class="xmgjBg" />
      </div>
      <div class="more">
        <div class="line"></div>
        <div class="flexR">
          <div class="name flex1">更多应用</div>
          <img src="../assets/imgs/more.png" class="moreImg" />
        </div>
      </div>
      <div class="appCell" v-for="(item, index) in appList" :key="item.code" :class="index % 2 != 0 ? '' : 'leftBox'">
        <div class="cellInfo" :class="index % 2 != 0 ? 'rightInfo' : 'leftInfo'">
          <img :src="item.logo" class="appLogo" />
          <div class="name">{{ item.name }}</div>
          <div class="introduce">{{ item.introduce }}</div>
          <el-button style="background-color:#28C792" round @click="downLoadApp(item.code)" v-if="item.code === 'xmxx'">立即下载</el-button>
          <el-button style="background-color:#FF4415" round @click="downLoadApp(item.code)" v-if="item.code === 'xmgj'">立即下载</el-button>
        </div>
        <img :src="item.bg" class="appBg" />
      </div>
      <div class="copyright">
        <p>Copyright © 2021 小马国炬 版权所有</p>
      </div>

      <div class="wxtip" id="JweixinTip">
        <div class="flex">
          <span class="close" @click="closetip()">×</span>
          <span class="wxtip-icon img">
            <img src="../assets/tip.png" alt="" />
          </span>
        </div>
        <p class="wxtip-txt">点击右上角<br />选择在浏览器中打开</p>
      </div>
      <!-- <div class="load" style="display:none">
                <p></p>
            </div> -->
      <!-- <div class="mask" style="display: none;">
                <div class="alert">
                    <div class="descript"></div>
                    <div class="confirm">
                        <button class="confirmBtn" type="button" onclick="closemask()">确定</button>
                    </div>
                </div>
            </div> -->
    </div>
    <Pad v-else-if="navtype == 2" />

    <Work v-else-if="navtype == 3" />
    <!-- 下载弹框 -->
    <DownLoadTip></DownLoadTip>
  </div>
</template>
<script src="./config/env.js"></script>
<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script src="http://m-cdn.saclub.com.cn/app/2.4/js/jquery-1.11.3.min.js"></script>
<script src="https://code.jquery.com/jquery-3.1.1.min.js"></script>
<script type="text/javascript">
import { API_URL } from "@/fetch/fetch";

import Pad from "./pad";
import Work from "./work";
import wx from "weixin-js-sdk";
import DownLoadTip from '../components/DownLoadTip.vue'
import Util from '../utils/index.js'
export default {
  components: { Pad, Work,DownLoadTip },
  data() {
    return {
      appList: [
        {
          name: "小马鲜鲜",
          introduce: "农产品批发管理系统",
          code: "xmxx",
          logo: require("../assets/imgs/xmxxLogo.png"),
          bg: require("../assets/imgs/xmxxBg.png"),
        },
        {
          name: "小马生活",
          introduce: "小马生活，省出美好生活",
          code: "xmgj",
          logo: require("../assets/imgs/xmgjLogo.png"),
          bg: require("../assets/imgs/xmszsqBg.png"),
        },
        // {
        //   name: "小马之家",
        //   introduce: "让工作更高效",
        //   code: "xmzj",
        //   logo: require("../assets/imgs/xmzjLogo.png"),
        //   bg: require("../assets/imgs/xmzjBg.png"),
        // },
        // {
        //     name: "小马国炬企业版",
        //     introduce: "企业化数字服务",
        //     code: "xmgj-enterprise",
        //     logo: require("../assets/imgs/enterpriseLogo.png"),
        //     bg: require("../assets/imgs/enterpriseBg.png"),
        // },
      ],
      navtype: 1,
    };
  },

  methods: {
    handleScroll() {
      console.log('监听滚动');
    },
    isWeiXin() {
      //是否是微信打开，并且提示引导
      var ua = window.navigator.userAgent.toLowerCase();
      //mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        $("#JweixinTip").attr("style", "display:none;");
        return true;
      } else {
        $("#JweixinTip").attr("style", "display:none;");
        return false;
      }
    },
    closetip() {
      //隐藏div
      $("#JweixinTip").attr("style", "display:none;"); //隐藏div
    },


    downLoadApp(name) {
      let flag = Util.judgeFlag()
      this.$store.commit('CHANGE_DOWNLOADNAME',name)
      this.$store.commit('CHANGE_TYPE',1)
      if(flag){
        this.$store.commit('CHANGE_SHOW',name)
        return
      }
      Util.downLoadApp()
    },
    changeNavBar(val) {
      this.navtype = val;
    },
    closemask() {
      $(".mask").css("display", "none");
    },
    wxReg() {
      $.ajax({
        url: "https://wxshare.guojutech.net/wx/wechatParam?url=" + encodeURIComponent(location.href.split("#")[0]),
        type: "get",
        cache: false,
        success: (res) => {
          if (res.success) {
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.data.appId, // 必填，公众号的唯一标识
              timestamp: res.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
              signature: res.data.signature, // 必填，签名
              jsApiList: ["updateAppMessageShareData"], // 必填，需要使用的JS接口列表
            });
            var title = "小马国炬应用商店";
            var imgUrl = "https://xmgj2020-prod.oss-cn-chengdu.aliyuncs.com/logo/2022/xmgj_logo.png";
            // var imgUrl = "./images/logo.png";
            var desc = "点击可立即下载小马国炬、小马生活，小马鲜鲜等App";
            var link = "https://appstore.guojutech.net?time=";
            wx.ready(() => {
              //需在用户可能点击分享按钮前就先调用
              wx.updateAppMessageShareData({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: imgUrl, // 分享图标
                success: function() {
                  // 设置成功
                },
              });
            });
            wx.error(function(res) {
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            });
          }
        },
      });
    },
  },
  mounted() {
    this.wxReg()
    this.isWeiXin();
    window.addEventListener("scroll", this.handleScroll); // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
    // this.closetip();
  },
};
</script>

<style lang="scss" scoped>
.main {
  height: 100%;
  width: 100vw;
  background-color: #f2f2f2;
  overflow: scroll;
}
.flexR {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -moz-box;
  display: flex;

  -webkit-box-orient: horizontal;
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;

  -webkit-box-pack: space-between;
  -webkit-justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  -o-justify-content: space-between;
  justify-content: space-between;

  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
.flex1 {
  -webkit-box-flex: 1; /* OLD - iOS 6-, Safari 3.1-6 */
  -moz-box-flex: 1; /* OLD - Firefox 19- */
  width: 20%; /* For old syntax, otherwise collapses. */
  -webkit-flex: 1; /* Chrome */
  -ms-flex: 1; /* IE 10 */
  flex: 1; /* NEW, Spec - Opera 12.1, Firefox 20+ */
}
.header {
  @media screen and (max-width: 768px) {
    height: 96px;
    .logo {
      // width: 191px;
      height: 48px;
      padding-left: 32px;
      display: block;
    }
  }
  @media screen and (min-width: 768px) {
    height: 72px;
    .logo {
      // width: 167px;
      height: 48px;
      padding-left: 32px;
      display: block;
    }
  }
  width: 100%;
  background-color: #fff;
  font-size: 28px;
  position: fixed;
  top: 0;
  backdrop-filter: blur(20px);
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 1;

  .appstore {
    color: #666666;
  }
  .pageName {
    padding-left: 16px;
    margin-left: 16px;
    color: #666666;
    border-left: 1px solid rgba(0, 0, 0, 0.3);
  }
  .workName {
    margin-right: 32px;
    padding-left: 16px;
    margin-left: 16px;
    color: #666666;
    border-left: 1px solid rgba(0, 0, 0, 0.3);
  }
}
.container {
  width: 100%;
  height: 100%;
  position: relative;
  position: absolute;
  background-color: #f2f2f2;
  // top: 96px;
  // 小马国炬板块
  @media screen and (max-width: 768px) {
    .xmgjInfo {
      width: 100%;
      position: absolute;
      top: 152px;
      text-align: center;
      .line {
        width: 40px;
        height: 8px;
        background: linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        margin: auto;
        margin-bottom: 36px;
      }
      .name {
        color: #262626;
        font-size: 56px;
        font-weight: bold;
        height: 78px;
        line-height: 78px;
        margin-bottom: 4px;
      }
      .introduce {
        font-size: 26px;
        font-weight: 400;
        color: #939599;
        margin-bottom: 36px;
      }
      ::v-deep .el-button--primary {
        width: 275px;
        height: 74px;
        background: #2a74f4 linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
        opacity: 1;
      }
      ::v-deep .el-button {
        font-size: 32px;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  @media screen and (min-width: 768px) {
    .xmgjInfo {
      width: 100%;
      position: absolute;
      top: 380px;
      text-align: center;
      .line {
        width: 80px;
        height: 16px;
        background: linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        margin: auto;
        margin-bottom: 36px;
      }
      .name {
        color: #262626;
        font-size: 96px;
        font-weight: bold;
        height: 120px;
        line-height: 120px;
        margin-bottom: 8px;
      }
      .introduce {
        font-size: 50px;
        font-weight: 400;
        color: #939599;
        margin-bottom: 64px;
      }
      ::v-deep .el-button--primary {
        width: 400px;
        height: 100px;
        background: #2a74f4 linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
        opacity: 1;
      }
      ::v-deep .el-button {
        font-size: 40px;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  .xmgjBg {
    width: 100%;
  }
  // 更多应用
  .more {
    margin-top: 56px;
    padding: 0 40px;
    margin-bottom: 21px;

    .line {
      background: linear-gradient(135deg, #d2e0fd 0%, #dce5fa 0%, #b0bad3 100%);
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      margin-bottom: 36px;
      @media screen and (max-width: 768px) {
        width: 40px;
        height: 8px;
      }
      @media screen and (min-width: 768px) {
        width: 80px;
        height: 12px;
      }
    }
    .name {
      font-size: 56px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: bold;
      color: #262626;
    }
    .moreImg {
      width: 382px;
      height: 52px;
    }
  }
  // 所有应用
  .appCell {
    position: relative;
    background-color: #f2f2f2;
    padding-right: 32px;
    .cellInfo {
      position: absolute;
      top: 100px;
      text-align: center;
      .name {
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 700;
        color: #262626;
      }
      .introduce {
        font-weight: 400;
        color: #939599;
      }
    }

    @media screen and (max-width: 768px) {
      .leftInfo {
        margin-left: 102px;
      }
      .rightInfo {
        right: 0;
        padding-right: 102px;
      }
      .appLogo {
        width: 104px;
        height: 104px;
        margin-bottom: 16px;
      }
      .appBg {
        width: 100%;
        margin-bottom: 21px;
      }
      .name {
        font-size: 32px;
        margin-bottom: 4px;
      }
      .introduce {
        font-size: 24px;
        margin-bottom: 24px;
      }
      ::v-deep .el-button--primary {
        width: 192px;
        height: 60px;
        background: #2a74f4 linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
        opacity: 1;
      }
      ::v-deep .el-button {
        font-size: 24px;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
    @media screen and (min-width: 768px) {
      .leftInfo {
        width: 50%;
        height: 94%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        // display: -webkit-box;
        // display: -webkit-flex;
        // display: -ms-flexbox;
        // display: -moz-box;
        // display: flex;

        // -webkit-box-orient: vertical;
        // -webkit-flex-direction: column;
        // -moz-flex-direction: column;
        // -ms-flex-direction: column;
        // -o-flex-direction: column;
        // flex-direction: column;

        // -webkit-box-pack: center;
        // -webkit-justify-content: center;
        // -moz-justify-content: center;
        // -ms-justify-content: center;
        // -o-justify-content: center;
        // justify-content: center;

        // -webkit-box-align: center;
        // -webkit-align-items: center;
        // -moz-align-items: center;
        // -ms-align-items: center;
        // -o-align-items: center;
        // align-items: center;
      }
      .rightInfo {
        width: 50%;
        height: 94%;
        right: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .appLogo {
        width: 200px;
        height: 200px;
        margin-bottom: 16px;
      }
      .appBg {
        width: 100%;
      }
      .name {
        font-size: 64px;
        margin-bottom: 8px;
        margin-top: 20px;
        color: red;
      }
      .introduce {
        font-size: 44px;
        margin-bottom: 44px;
      }
      ::v-deep .el-button--primary {
        width: 50%;
        height: 100px;
        background: #2a74f4 linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
        opacity: 1;
      }
      ::v-deep .el-button {
        font-size: 36px;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
  .leftBox {
    padding-left: 32px;
    padding-right: 0;
  }

  .copyright {
    background-color: #f2f2f2;
    padding: 24px 0 40px 0;
    text-align: center;
    font-size: 24px;
    color: #999999;
  }
}

::v-deep .el-button.is-round {
  border-radius: 87px 87px 87px 87px;
}

.wxtip {
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 998;
  display: none;
}

#JweixinTip .flex {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  top: 40px;
  left: 40px;
  width: 96%;
  margin: 0 auto;
  color: white;
}
.wxtip-icon {
  width: 52px;
  height: 67px;
  display: block;
  position: absolute;
  right: 20px;
}
.wxtip-icon img {
  width: 100%;
  height: 80px;
  right: 50px;
  position: absolute;
  top: 15px;
}
.wxtip-txt {
  margin-top: 80px;
  color: #fff;
  font-size: 26px;
}
.close {
  font-size: 46px;
}
.active {
  font-weight: 700;
  color: #333;
}
.noactive {
  font-weight: 400;
  color: #666;
}
</style>
